<template>
  <div class="navigation1">
    <header class="header-v4 stricky">
      <div class="container">
        <div class="header clearfix">
          <div class="logo pull-left">
            <a href="/">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577365019/afrikeveil/aeLogo.png"
                alt
              />
            </a>
          </div>
          <div class="main-menu pull-right">
            <ul class="menu">
              <li class="active">
                <router-link
                  :to="`/${$i18n.locale}/${this.$i18n.t('routes.home')}`"
                >{{ $t("navBar.home") }}</router-link>
              </li>
              <li class="hvr-icon-drop">
                <a>
                  {{ $t("navBar.about") }}
                  <span class="fa fa-sort-desc"></span>
                </a>
                <div class="sub-menu">
                  <ul>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.howWeWork')}`
                        "
                      >{{ $t("navBar.howWeWork") }}</router-link>
                    </li>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t(
                            'routes.ourOrganization'
                          )}`
                        "
                      >{{ $t("navBar.ourOrganization") }}</router-link>
                    </li>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t(
                            'routes.ourHistory'
                          )}`
                        "
                      >{{ $t("navBar.ourHistory") }}</router-link>
                    </li>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.ourTeam')}`
                        "
                      >{{ $t("navBar.ourTeam") }}</router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <router-link :to="`/${$i18n.locale}/${this.$i18n.t('routes.ghanaHub')}`">GHANA HUB</router-link>
              </li>
              <li class="hvr-icon-drop">
                <a>
                  PUBLICATIONS
                  <span class="fa fa-sort-desc"></span>
                </a>
                <div class="sub-menu">
                  <ul>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.ourNews')}`
                        "
                      >{{ $t("navBar.ourNews") }}</router-link>
                    </li>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.ourBlogs')}`
                        "
                      >{{ $t("navBar.ourBlogs") }}</router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="active">
                <router-link
                  :to="`/${$i18n.locale}/${this.$i18n.t('routes.covid19')}`"
                >{{ $t("navBar.covid19") }}</router-link>
              </li>
              <li class="hvr-icon-drop">
                <a>{{ $t("navBar.interrested") }}</a>
                <div class="sub-menu">
                  <ul>
                    <li>
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.joinUs')}`
                        "
                      >{{ $t("navBar.joinUs") }}</router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`/${$i18n.locale}/${this.$i18n.t('routes.don')}`"
                      >{{ $t("navBar.don") }}</router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <router-link :to="`/${$i18n.locale}/our-projects`">
                  {{
                  $t("navBar.ourProjects")
                  }}
                </router-link>
              </li>
              <li>
                <router-link :to="`/${$i18n.locale}/${this.$i18n.t('routes.contact')}`">contact</router-link>
              </li>
              <LanguageSwitcher />
            </ul>
          </div>
          <div class="bars pull-right">
            <div class="bar-mobile open">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="mobile-menu">
            <nav class="nav-holder">
              <ul>
                <li class="garden-hv-child-color-primary">
                  <router-link
                    :to="`/${$i18n.locale}/${this.$i18n.t('routes.home')}`"
                  >{{ $t("navBar.home") }}</router-link>
                </li>
                <li class="has-submenu garden-hv-child-color-primary">
                  <a>{{ $t("navBar.about") }}</a>
                  <ul class="submenu">
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.howWeWork')}`
                        "
                      >{{ $t("navBar.howWeWork") }}</router-link>
                    </li>
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t(
                            'routes.ourOrganization'
                          )}`
                        "
                      >{{ $t("navBar.ourOrganization") }}</router-link>
                    </li>
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t(
                            'routes.ourHistory'
                          )}`
                        "
                      >{{ $t("navBar.ourHistory") }}</router-link>
                    </li>
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.ourTeam')}`
                        "
                      >{{ $t("navBar.ourTeam") }}</router-link>
                    </li>
                  </ul>
                </li>
                <li class="garden-hv-child-color-primary">
                  <router-link :to="`/${$i18n.locale}/${this.$i18n.t('routes.ghanaHub')}`">GHANA HUB</router-link>
                </li>
                <li class="has-submenu garden-hv-child-color-primary">
                  <a href="#">PUBLICATIONS</a>
                  <ul class="submenu">
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.ourNews')}`
                        "
                      >{{ $t("navBar.ourNews") }}</router-link>
                    </li>
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.ourBlogs')}`
                        "
                      >{{ $t("navBar.ourBlogs") }}</router-link>
                    </li>
                  </ul>
                </li>
                <li class="has-submenu garden-hv-child-color-primary">
                  <a>{{ $t("navBar.interrested") }}</a>
                  <ul class="submenu">
                    <li class="garden-hv-child-color-primary">
                      <router-link
                        :to="
                          `/${$i18n.locale}/${this.$i18n.t('routes.joinUs')}`
                        "
                      >{{ $t("navBar.joinUs") }}</router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`/${$i18n.locale}/${this.$i18n.t('routes.don')}`"
                      >{{ $t("navBar.don") }}</router-link>
                    </li>
                  </ul>
                </li>
                <li class="garden-hv-child-color-primary">
                  <router-link :to="`/${$i18n.locale}/our-projects`">
                    {{
                    $t("navBar.ourProjects")
                    }}
                  </router-link>
                </li>
                <li class="garden-hv-child-color-primary">
                  <router-link :to="`/${$i18n.locale}/${this.$i18n.t('routes.contact')}`">contact</router-link>
                </li>
                <LanguageSwitcher mobile="yes" />
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "Navigation"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-v1 .header .main-menu li a,
.header-v2 .header .main-menu li a,
.header-v3 .header .main-menu li a,
.header-v5 .header .main-menu li a,
.header-v4 .header .main-menu li a {
  font-size: 12px;
  text-transform: uppercase;
  padding: 0 15px;
  z-index: 1000000;
  /* background: green !important; */
}
.mobile-menu .nav-holder > ul > li > a,
.mobile-menu .nav-holder > ul > li ul.submenu li > a,
.mobile-menu .nav-holder > ul > li {
  text-transform: uppercase;
}
</style>
